import { routesNames } from '@/core/constants'
import ModalDesentranhamento from '@/views/pages/pedido/acessar/documentos/desentranhamento/ModalDesentranhamento.vue'
import desentranhamentoRoutes from '@/views/routers/routes/pedido/processo-digital/desentranhamento/desentranhamento'

export default [
	{
		name: routesNames.PEDIDO.PROCESSO_DIGITAL.DESENTRANHAMENTO.DESENTRANHAR_DOCUMENTO_PROCESSO_DIGITAL_VIEW,
		path: '/pedido/:id/processo-digital/:idTermo/desentranhar/',
		component: ModalDesentranhamento,
		children: [...desentranhamentoRoutes],
	},
]
